import { MICROSERVICES } from '@shared/constants/microservices';

interface MockPathRule {
    path: string;
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
    header?: string;
}

interface MockRule {
    serviceKey: keyof typeof MICROSERVICES;
    paths: MockPathRule[];
}

export const MOCK_RULES: MockRule[] = [
    {
        serviceKey: 'accounts',
        paths: [
            // { path: '/user', method: 'GET', header: 'example=subscriptionType_legacy' },
            // { path: '/user', method: 'GET', header: 'example=payment_method' },
            // { path: '/user', method: 'GET', header: 'example=no_vehicle_created' },
            // { path: '/user', method: 'GET', header: 'example=subscriptionType_gold' },
            // { path: '/user', method: 'GET', header: 'example=termsAndConditionsNOTAccepted' },
            // { path: '/user', method: 'PATCH', header: 'example=subscriptionType_silver' }
        ],
    },
    {
        serviceKey: 'vehicles',
        paths: [
            // { path: '/vehicles', method: 'POST', header: 'code=200' },
            // { path: '/vehicles/csv', method: 'POST', header: 'code=423' },
            // { path: '/vehicles/:id', header: 'example=vehicle-status' },
            // { path: '/vehicles', method: 'GET',header: 'example=empty' },
        ],
    },
    {
        serviceKey: 'payments',
        paths: [
            // { path: '/payments', method: 'GET', header: 'example=groupType_BusinessSubscription' },
            // { path: '/payments/:id', header: 'example=status_error' },
            // { path: '/payments/retry-failed', method: 'POST', header: 'code=202' },
            // { path: '/payments/retry-failed', method: 'POST', header: 'code=422' },
        ],
    },
    {
        serviceKey: 'tolling',
        paths: [
            // { path: '/activities/:id', header: 'example=anyIntegrator_Error' },
            // { path: '/activities', header: 'example=paidWithDiscountsAndRefunds' },
        ],
    },
    {
        serviceKey: 'address_book',
        paths: [
            // { path: '/addresses' },
        ],
    },
    {
        serviceKey: 'b2c',
        paths: [
            // { path: '/signup', method: 'POST' },
        ],
    },
    {
        serviceKey: 'invoices',
        paths: [
            // { path: '/invoices/:id', header: 'example=subscription_plan_invoice' },
            // { path: '/invoices', header: 'example=regular_invoices' },
        ],
    },
];

export type { MockPathRule, MockRule };
